import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutGrid1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-grid-1, grid, window"} maskId="square-filled-radius-0-stroke-1-IconLayoutGrid1"><path d="M3 3V9H11V3H3Z" fill="currentColor"/><path d="M13 3V13H21V3H13Z" fill="currentColor"/><path d="M3 11V21H11V11H3Z" fill="currentColor"/><path d="M13 15V21H21V15H13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutGrid1;
